import { mapIssueCalendarInfo } from '../mappers/issue.calendar';
import { getIssueCalendarInfo as svcGetIssueCalendarInfo } from '../services/calendar';

async function getIssueCalendarInfo(cid: string) {
    const dto = await svcGetIssueCalendarInfo(cid);
    return mapIssueCalendarInfo(dto);
}

export { getIssueCalendarInfo };
